<div id="package-details-default-view">
    <hyperkit-tab-bar [variant]="'primary'" [mode]="'underline'">
      <hyperkit-tab
        [text]="'Overview'"
        [selected]="hunt.ui.defaultViewTab() === 'overview'"
        (tabClick)="hunt.ui.defaultViewTab.set('overview')"
      >
        <default-overview-tab *ngIf="hunt.ui.defaultViewTab() === 'overview'"></default-overview-tab>
      </hyperkit-tab>
  
      <hyperkit-tab
        [text]="'Query Logic'"
        [selected]="hunt.ui.defaultViewTab() === 'query-logic'"
        (tabClick)="hunt.ui.defaultViewTab.set('query-logic')"
      >
        <default-query-logic-tab *ngIf="hunt.ui.defaultViewTab() === 'query-logic'"></default-query-logic-tab>
      </hyperkit-tab>
    </hyperkit-tab-bar>
  </div>
  